import React, { useState } from 'react';
import { auth } from './firebaseConfig';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
import { useTranslation } from 'react-i18next';

function Auth({ setUser }) {
  const { t, i18n } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSignUp, setIsSignUp] = useState(false);
  const [error, setError] = useState(null);

  const handleAuth = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      let userCredential;
      if (isSignUp) {
        userCredential = await createUserWithEmailAndPassword(auth, email, password);
      } else {
        userCredential = await signInWithEmailAndPassword(auth, email, password);
      }
      setUser(userCredential.user);
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="auth-page-wrapper">
      <div className="auth-page">
        <div className="info-column">
          <img src="/POD_300x300.png" alt="POD Logo" className="auth-logo" />
          <h1>{t('login.title')}</h1>
          <p>{t('login.subtitle')}</p>
        </div>
        <div className="auth-column">
          <div className="auth-container">
            <form onSubmit={handleAuth} className="auth-form">
              <h2>{isSignUp ? t('signUp') : t('logIn')}</h2>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t('email')}
                required
              />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder={t('password')}
                required
              />
              <button type="submit">{isSignUp ? t('signUp') : t('logIn')}</button>
              {error && <p className="error">{error}</p>}
            </form>
            <button onClick={() => setIsSignUp(!isSignUp)} className="auth-toggle">
              {isSignUp ? t('alreadyHaveAccount') : t('dontHaveAccount')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Auth;